import { Component, Input, OnInit } from '@angular/core';
import { EventsService, UtilService, VariablesService, VwoService } from '../../../../shared/services';

@Component({
  selector: 'app-social-strip',
  templateUrl: './social-strip.component.html',
  styleUrls: ['./social-strip.component.scss']
})
export class SocialStripComponent implements OnInit {

  @Input() public isMobile: any;
  @Input() config;

  DEFAULT_CONFIG = {
    showArrows: true,
    autoplay: false,
    showHeading: false,
    theme: ''
  };

  breakpoints = {
    600: { perView: 1.1, gap: 0 }
  };

  tweets = [
    { redirect_to: 'https://twitter.com/juniorbachchan/status/1242812685114195968?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1242812685114195968%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twitter_slide_2.png' },
    { redirect_to: 'https://twitter.com/itsSSR/status/1063296115456524295?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1063296115456524295%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twitter_slide_3.png' },
    { redirect_to: 'https://twitter.com/sardesairajdeep/status/1093139679736664070?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1093139679736664070%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twiter_slide_5.png' },
    { redirect_to: 'https://twitter.com/ShraddhaKapoor/status/1090161898786562048?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1090161898786562048%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twitter_slide_6.png' },
    { redirect_to: 'https://twitter.com/akshaykumar/status/959084395163512833?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E959084395163512833%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twitter_slide_7.png' },
    { redirect_to: 'https://twitter.com/sonamakapoor/status/959106788305047553?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E959106788305047553%7Ctwgr%5E%7Ctwcon%5Es1_', image: '/assets/images/twitter-slide/twitter_slide_8.png' }
  ];

  constructor(
    public variablesService: VariablesService,
    public vwo: VwoService,
    public util: UtilService,
    private eventsService: EventsService
  ) {
  }

  ngOnInit() {
    this.config = { ...this.DEFAULT_CONFIG, ...this.config };
    if (this.config?.theme) {
      this.breakpoints[600].perView = 1.2;
      this.breakpoints[600].gap = 20;
    }
  }

  goToTweetEvent() {
    this.eventsService.sendSystemEvent({
      eventName: 'twitter_card_click',
      page_name: this.variablesService.pageName,
      info_1: 'type',
      info_2: 1
    }).subscribe(_ => _);
  }

}
